import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { useIntl } from 'react-intl-next';
import { AutoDismissFlag } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { G300 } from '@atlaskit/theme/colors';
import { messages } from '../messages';
import { IntlProviderWithResolvedMessages } from './IntlProviderWithResolvedMessages';
var FeedbackFlag = function FeedbackFlag(_ref) {
  var description = _ref.description,
    title = _ref.title;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(AutoDismissFlag, {
    icon: /*#__PURE__*/React.createElement(SuccessIcon, {
      primaryColor: "var(--ds-icon-success, ".concat(G300, ")"),
      label: "Success"
    }),
    id: "feedbackSent",
    description: description || formatMessage(_objectSpread({}, messages.feedbackSuccessFlagDescription)),
    title: title || formatMessage(_objectSpread({}, messages.feedbackSuccessFlagTitle))
  });
};
var FeedbackFlagWithIntl = function FeedbackFlagWithIntl(props) {
  return /*#__PURE__*/React.createElement(IntlProviderWithResolvedMessages, {
    locale: props.locale
  }, /*#__PURE__*/React.createElement(FeedbackFlag, props));
};
export default FeedbackFlagWithIntl;